import * as React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import CheckoutAdditionalServiceComponent, {
	ControlsRenderers,
	Props
} from '@websky/core/src/CheckoutAdditionalService/CheckoutAdditionalService/CheckoutAdditionalService';
import { AdditionalServiceType } from '@websky/core/src/CheckoutAdditionalService/types';
import { getBusinessLounge, getOrder, getPriorityBoarding } from '@websky/core/src/Checkout/store/order/selectors';
import Button from '@websky/core/src/Button';
import { Switch } from '@websky/core/src/__fsd__/shared/ui';
import css from './CheckoutAdditionalService.css';
import { getIatasByServices } from './utils';

const CheckoutAdditionalService: React.FC<Props> = props => {
	const { t } = useTranslation('CheckoutAdditionalService');

	const order = useSelector(getOrder);
	const businessLoungeServices = useSelector(getBusinessLounge);
	const priorityServices = useSelector(getPriorityBoarding);

	const isBusinessLounge = props.serviceType === AdditionalServiceType.BusinessLounge;
	const isPriorityBoarding = props.serviceType === AdditionalServiceType.PriorityBoarding;
	const isInsurance = props.serviceType === AdditionalServiceType.Insurance;

	let iatas: string[] = [];

	if (isBusinessLounge) {
		iatas = getIatasByServices(businessLoungeServices, order.flight.segments);
	}

	if (isPriorityBoarding) {
		iatas = getIatasByServices(priorityServices, order.flight.segments);
	}

	const renderControls = (props: ControlsRenderers) => {
		return (
			<div className={css.controls}>
				{props.isSelected &&
					props.buttons?.map(button => {
						const isChangeButton = button.buttonType === 'change';

						return (
							<Button
								key={button.text}
								isLoading={button.isLoading}
								onClick={button.action}
								variant="text"
								size="common"
							>
								{button.text}
								{isChangeButton && <Switch checked={true} />}
							</Button>
						);
					})}

				{!props.isSelected && props.showAddButton !== false && (
					<Button className={css.add} variant="text" isLoading={props.isLoading} onClick={props.addClick}>
						{props.addButtonText ? t(props.addButtonText) : t('Add')}
						<Switch checked={false} />
					</Button>
				)}
			</div>
		);
	};

	return (
		<CheckoutAdditionalServiceComponent
			{...props}
			className={cn(props.className, {
				[css.business]: isBusinessLounge,
				[css.priorityBoarding]: isPriorityBoarding,
				[css.bg_zia]: iatas.includes('ZIA'),
				[css.bg_aer]: iatas.includes('AER')
			})}
			header={isPriorityBoarding ? priorityServices[0]?.name ?? props.header : props.header}
			priceFrom={isPriorityBoarding ? (props.isSelected ? props.priceFrom : null) : props.priceFrom}
			renderControls={renderControls}
			hideFrom={isInsurance && props.servicesCount <= 1}
		/>
	);
};

export default CheckoutAdditionalService;
